import React, { useEffect, useLayoutEffect, useState } from "react";
import { Map, Marker, TileLayer, Popup, Polyline } from "react-leaflet";
import L from "leaflet";
import Pin from "../Pin";
import ReactDOMServer from "react-dom/server";
import { useDispatch, useSelector } from "react-redux";
import styles from './style.module.css';
import { AddMonitoringOrdersBounding, ChangeViewTravelDialoge, SetDriverPopUp, SetOrderPinPopUp, SetOrderPinPopUpPosition, SetSelectedMonitoringDriver, SetSelectedMonitoringOrder } from "../../../../Redux/actions/actionNames";
import { GetColorByStatus } from "../../../../utils/get-colors-by-status";
import { useMonitoringPin } from "../../../../hooks/useMonitoringPin";
import { useTranslation } from "react-i18next";
import { getFavAddressListAction, OrderInfoAction } from "../../../../Redux/actions/actions";
import "./customPopup.css";
import history from "../../../../service/history";
import { isEmpty } from "lodash";
import { HASHTAG, personGrey, PickupOnly_Deactive } from "../../../../assets";
import Tag from "../../../../design-system/lib/Tag";
import Typography from "../../../../design-system/lib/Typography";


const App = () => {
  const OrderPinPopUp = useSelector((state) => state.Monitoring.OrderPinPopUp)
  const OrderPinPopUpPosition = useSelector((state) => state.Monitoring.OrderPinPopUpPosition)

  if (!OrderPinPopUp || !OrderPinPopUpPosition) {
    return null
  }
  return <CreatePopup OrderPinPopUp={OrderPinPopUp} OrderPinPopUpPosition={OrderPinPopUpPosition} />

};

export default App


const CreatePopup = ({ OrderPinPopUp, OrderPinPopUpPosition }) => {
  const [width, setWidth] = useState(0);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const mapRef = useSelector((state) => state.Map.mapRef)

  function OpenOrderDetails(){
    let data= JSON.parse(JSON.stringify(OrderPinPopUpPosition))
    history.push(`/order/${data.orderId}`);
    dispatch(
      ChangeViewTravelDialoge(true, data.orderId, null)
    );

    // dispatch(
    //   OrderInfoAction(dispatch, {
    //     orderId: data.orderId,
    //   })
    // );
    data.customerId && dispatch(
      getFavAddressListAction(dispatch, { id: data.customerId, page: 0, perpage: 100 })
    );
    // dispatch(
    //   ChangeViewTravelDialoge(true, data.orderId, data.customerId)
    // );

    disableSelectedDriver()
  }

  function disableSelectedDriver(){
    dispatch(SetSelectedMonitoringOrder(null))
    dispatch(SetSelectedMonitoringDriver(null))
    dispatch(SetDriverPopUp(null))
    dispatch(SetOrderPinPopUp(null))
    dispatch(SetOrderPinPopUpPosition(null))
    mapRef.current.leafletElement.closePopup()
    dispatch(AddMonitoringOrdersBounding({ordersBoundingList : [] , ordersBoundingDriver: null},"852"))
  }

  // useLayoutEffect(() => {

  //   if ( OrderPinPopUpPosition && !width) {
  //   setTimeout(() => {
  //     var element = document.getElementById(`${OrderPinPopUp}popup`);
  //     var positionInfo = element && element.getBoundingClientRect();
  //     var width = positionInfo && positionInfo.width;
  //     width && setWidth(width);
  //   }, 100);
  //   }
  // }, [OrderPinPopUpPosition]);


  return <Popup position={OrderPinPopUpPosition.position} onClose={disableSelectedDriver} id={`${OrderPinPopUp?.id}popup`} className={"monitoringDriverSelected markerIcon orderPin " + styles.OsmMarkerPopUp} >
         <div style={{ height: "auto" , width:"max-content" , display:"flex" ,flexDirection:"column" , justifyContent:"center" ,alignItems:"center" }}>
          <div style={{ height: "auto" ,display:"flex",flexDirection:"column", justifyContent:"center",alignItems:"center" ,gap:"8px" }}>
            <Typography weight="Body_Middle_Medium" text={OrderPinPopUp[OrderPinPopUp?.category].address} style={{
              color: "#242424", textDecoration: 'none',
              textOverflow: 'ellipsis', whitespace: 'nowrap', overflow: 'hidden',maxWidth :"400px"
            }} />
            <div style={{gap:"6px",width:"100%" ,display:"flex" , flexDirection:"row" , justifyContent:"start" ,alignItems:"center"}}>
              <Tag backgroundColor="GrayUltraLight" color="TextNormal" size="Medium" text={OrderPinPopUp.code} weight="Body_Small_Regular" icon={HASHTAG} iconSize="16"  className={styles.feiiihsid} />
              <Tag backgroundColor="GrayUltraLight" color="TextNormal" size="Medium" text={t(OrderPinPopUp.category)} weight="Body_Small_Regular" icon={PickupOnly_Deactive} iconSize="16"  className={styles.feiiihsid} />
              {!isEmpty(OrderPinPopUp[OrderPinPopUp.category].fullName) && <Tag backgroundColor="GrayUltraLight" color="TextNormal" size="Medium" text={OrderPinPopUp[OrderPinPopUp.category].fullName} weight="Body_Small_Regular" icon={personGrey} iconSize="16"  className={styles.feiiihsid} />}
            </div>
          </div>
          <div style={{width :"100%" ,height:"1px" , marginTop:"8px" , backgroundColor:"#F4F4F7"}} />
          <span className={styles.OsmMarkerPopUpButton} style={{marginTop:"8px"}} onClick={OpenOrderDetails}> {t("Details") } </span>

        </div>
    </Popup>

}



